import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-yes.svg";
import * as styles from "./Icon.module.scss";

type IconYesProps = React.SVGProps<SVGSVGElement>;

export const IconYes = ({ className, ...props }: IconYesProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
